import { atom } from 'recoil';

export const notificationsAtom = atom({
  key: 'notifications',
  default: [],
});

export const userAtom = atom({
  key: 'user',
  default: null,
});

export const isLoggingInAtom = atom({
  key: 'isLoggingIn',
  default: false,
});

export const tokenAtom = atom({
  key: 'token',
  default: null,
});

export const alertAtom = atom({
  key: 'alert',
  default: {
    show: false,
    title: '',
    content: '',
    onClick: null,
  },
});

export const stateAtom = atom({
  key: 'currentState',
  default: null,
});

export const menuSideBarAtom = atom({
  key: 'menuSideBar',
  default: false,
});

export const mainPageInitializeAtom = atom({
  key: 'mainPageInitialize',
  default: true,
});

export const userPrivilagesAtom = atom({
  key: 'userPrivilages',
  default: { },
});

export const viewLeadAtom = atom({
  key: 'viewLead',
  default: null
});

export const viewLeadLogsAtom = atom({
  key: 'viewLeadLogs',
  default: null
});

export const addLeadLogAtom = atom({
  key: 'addLeadLog',
  default: null
});

export const viewLeadAssignedAtom = atom({
  key: 'viewLeadAssigned',
  default: null
});

export const assignOrgAtom = atom({
  key: 'assignOrg',
  default: null
});

export const viewLeadFilesAtom = atom({
  key: 'viewLeadFiles',
  default: null
});

export const viewContactsAtom = atom({
  key: 'viewContacts',
  default: null
});

export const addLeadFileAtom = atom({
  key: 'addLeadFile',
  default: null
});

export const createNewLeadAtom = atom({
  key: 'createNewLead',
  default: null
});

export const userOrganizationsAtom = atom({
  key: 'userOrganizations',
  default: []
});

export const reloadLeadsAtom = atom({
  key: 'reloadLeads',
  default: false
});

export const myLeadsHeaderAtom = atom({
  key: 'myLeadsHeader',
  default: {
    loading: false,
    totalPending: 0,
    totalAssigned: 0,
    totalClosed: 0,
    totalLost: 0,
    totalPendingAssigned: 0,
    totalPendingNoAppointment: 0,
    totalInstalled: 0,
    totalActivated: 0,
    totalLostDisengaged: 0,
    totalLostFailedCredit: 0,
    totalLostCancelled: 0,
    totalRevisit: 0,
    totalFailedCredit: 0
  }
});

export const payoutsHeaderAtom = atom({
  key: 'payoutsHeader',
  default: {
    loading: false,
    scheduledInstalls: 0,
    installed: 0,
    scheduledPayments: 0,
    totalLeads: 0,
    leads: [],
    selectedCloser: '',
    selectedSetter: '',
    reload: false
  }
});

export const editContactAtom = atom({
  key: 'editContact',
  default: {
    reload: false,
    contact: null
  }
});

export const markLeadLostAtom = atom({
  key: 'markLeadLost',
  default: null
});

export const graphsDateRangeAtom = atom({
  key: 'graphsDateRange',
  default: { start: null, end: null }
});

export const newSubmissionAtom = atom({
  key: 'newSubmission',
  default: null
});
